/**
 * Enum para los tipos de socios de negocio
 * Basado en la configuración del sistema
 */
export enum BusinessPartnerTypeEnum {
  CLIENTE = 'BPT0001',
  VENDEDOR = 'BPT0002',
  ENTREGADOR = 'BPT0003',
  NUEVO_CLIENTE = 'BPT0004',
  CONSUMIDOR_FINAL = 'BPT9001',
  CLIENTE_EVENTUAL = 'BPT9002'
}

/**
 * Obtiene la descripción en español del tipo de socio de negocio
 */
export function getBusinessPartnerTypeDescription(type: string): string {
  switch (type) {
    case BusinessPartnerTypeEnum.CLIENTE:
      return 'Cliente';
    case BusinessPartnerTypeEnum.VENDEDOR:
      return 'Vendedor';
    case BusinessPartnerTypeEnum.ENTREGADOR:
      return 'Entregador';
    case BusinessPartnerTypeEnum.NUEVO_CLIENTE:
      return 'Nuevo Cliente';
    case BusinessPartnerTypeEnum.CONSUMIDOR_FINAL:
      return 'Consumidor Final';
    case BusinessPartnerTypeEnum.CLIENTE_EVENTUAL:
      return 'Cliente Eventual';
    default:
      return '';
  }
}

/**
 * Obtiene el icono Material para el tipo de socio de negocio
 */
export function getBusinessPartnerTypeIcon(type: string): string {
  switch (type) {
    case BusinessPartnerTypeEnum.CLIENTE:
      return 'business';
    case BusinessPartnerTypeEnum.VENDEDOR:
      return 'badge';
    case BusinessPartnerTypeEnum.ENTREGADOR:
      return 'local_shipping';
    case BusinessPartnerTypeEnum.NUEVO_CLIENTE:
      return 'person_add';
    case BusinessPartnerTypeEnum.CONSUMIDOR_FINAL:
      return 'person_outline';
    case BusinessPartnerTypeEnum.CLIENTE_EVENTUAL:
      return 'person';
    default:
      return '';
  }
}

/**
 * Obtiene el color para el tipo de socio de negocio
 */
export function getBusinessPartnerTypeColor(type: string): string {
  switch (type) {
    case BusinessPartnerTypeEnum.CLIENTE:
      return '#424242';
    case BusinessPartnerTypeEnum.VENDEDOR:
      return '#7B1FA2';
    case BusinessPartnerTypeEnum.ENTREGADOR:
      return '#F57C00';
    case BusinessPartnerTypeEnum.NUEVO_CLIENTE:
      return '#388E3C';
    case BusinessPartnerTypeEnum.CONSUMIDOR_FINAL:
      return '#1976d2';
    case BusinessPartnerTypeEnum.CLIENTE_EVENTUAL:
      return '#2e7d32';
    default:
      return '#757575';
  }
}
